export default "__VITE_ASSET__DnA4YS8p__"